import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainBarSection } from './components/PainBarSection';
import { RevelationSection } from './components/RevelationSection';
import { PhasesSection } from './components/PhasesSection';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { ValueStackSection } from './components/ValueStackSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    ;
    (window as any).fbq('init', '759566727183941');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <main className="w-full min-h-screen bg-[#FDF6F0] text-[#2D2028] overflow-x-hidden" data-id="element-0">
      <UrgencySection data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainBarSection data-id="element-3" />
      <RevelationSection data-id="element-4" />
      <PhasesSection data-id="element-5" />
      <ProductSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <ValueStackSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTASection data-id="element-12" />
      <RecentPurchaseToast data-id="element-13" />

      {/* Footer Simple */}
      <footer className="py-8 text-center text-[#6B5B65] text-sm border-t border-[#E8D8E0] bg-[#F3E8F0]" data-id="element-14">
        <p data-id="element-15">
          © {new Date().getFullYear()} Código Hormonal. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-16">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </main>;
}